import { useEffect, useState } from "react";

/**
 * The shell's three layouts, on the design mock's breakpoints
 * (`weco2/responsive.css`):
 *   mobile  < 768   condensed header, bottom nav, apps sheet, no sidebar
 *   tablet  768–1023 64px rail in flow; expanding overlays with a scrim
 *   desktop >= 1024 sidebar pushes the content (64px rail <-> 256px)
 */
export type ShellViewport = "mobile" | "tablet" | "desktop";

const MOBILE_QUERY = "(max-width: 767.98px)";
const TABLET_QUERY = "(min-width: 768px) and (max-width: 1023.98px)";

function read(): ShellViewport {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return "desktop";
  if (window.matchMedia(MOBILE_QUERY).matches) return "mobile";
  if (window.matchMedia(TABLET_QUERY).matches) return "tablet";
  return "desktop";
}

export function useShellViewport(): ShellViewport {
  const [vp, setVp] = useState<ShellViewport>(read);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const queries = [window.matchMedia(MOBILE_QUERY), window.matchMedia(TABLET_QUERY)];
    const sync = () => setVp(read());
    sync();
    for (const q of queries) {
      if (typeof q.addEventListener === "function") q.addEventListener("change", sync);
      else q.addListener(sync);
    }
    return () => {
      for (const q of queries) {
        if (typeof q.removeEventListener === "function") q.removeEventListener("change", sync);
        else q.removeListener(sync);
      }
    };
  }, []);
  return vp;
}
